import { useReducer } from "react";
import { initialState, reducer, } from 'store/confirmReducer';
import ConfirmContext from 'store/ConfirmContext';

export const ConfirmContextProvider = ({ children }) => {
    const [confirmState, confirmDispatch] = useReducer(reducer, initialState);

    return (
        <ConfirmContext.Provider value={[confirmState, confirmDispatch]}>
            {children}
        </ConfirmContext.Provider>
    )
}